export default __webpack_public_path__ + "static/media/5.12daaab4.webp";